import { ButtonPrimary } from 'fukku/Button/Primary'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { sendOnLoadingRetry } from 'my-purchases/utils/analytics/analyticsEvents'
import { useSession } from 'session/src/hooks/useSession'

import styles from './AllPurchasesError.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface AllPurchasesErrorProps {
	readonly retryCallback?: () => void
}
export function AllPurchasesError({ retryCallback }: AllPurchasesErrorProps) {
	const { t } = useLabels()
	const { name } = useSession()

	const handleRetryLoad = () => {
		sendOnLoadingRetry()
		retryCallback?.()
	}

	return (
		<div className={styles.container}>
			<p className={text.bodyL}>
				<ClientLabel placeholderValues={{ 1: name ?? '' }}>
					{t('myPurchases.errorAll.bodycopy.logged')}
				</ClientLabel>
			</p>
			<ButtonPrimary onClick={handleRetryLoad} className={styles.button}>
				{t('myPurchases.errorAll.retry.button')}
			</ButtonPrimary>
		</div>
	)
}
